import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { default as ReactDatePicker, registerLocale } from 'react-datepicker'
import * as moment from 'moment';
import ja from 'date-fns/locale/ja';

import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/react-datepicker.override.css";

ja.options.weekStartsOn = 0;
registerLocale('ja', ja);

const styles = () => ({
  rangeContainer: {
    display: 'flex',
  },

  datePickerInput: {
    font: 'inherit',
    outline: '0',
    margin: '0',
    padding: '10px 12px',
    fontSize: '15px',
    boxSizing: 'content-box',
    border: '1px solid #ced4da',
    borderRadius: '2px',
    verticalAlign: 'middle',
    width: '90px',
    '&:focus': {
      border: '1px solid #1A65FF',
    },
  },

  separator: {
    margin: 'auto 12px',
  }
});

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: props.startDate,
      endDate: props.endDate,
    };
  }

  handleBack = () => {
    this.datePicker.setState({
      open: false,
    });
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });

    if (this.props.handleChange) {
      this.props.handleChange(date);
    }
  }

  handleChangeStart = (date) => {
    const startDate = date;
    const endDate = moment(date).diff(moment(this.state.endDate)) > 0 ? date : this.state.endDate;
    this.setState({
      startDate: startDate,
      endDate: endDate,
    });

    if (this.props.handleChange) {
      this.props.handleChange(startDate, endDate);
    }
  }

  handleChangeEnd = (date) => {
    const startDate = moment(date).diff(moment(this.state.startDate)) < 0 ? date : this.state.startDate;
    const endDate = date;
    this.setState({
      startDate: startDate,
      endDate: endDate,
    });

    if (this.props.handleChange) {
      this.props.handleChange(startDate, endDate);
    }
  }

  render() {
    if (this.props.isRange) {
      return (
        <div className={this.props.classes.rangeContainer}>
          <ReactDatePicker
            id="date-picker-1"
            locale="ja"
            dateFormat={"yyyy/MM/dd"}
            dateFormatCalendar={"yyyy年MM月"}
            ref={(datePicker) => { this.datePickerStart = datePicker }}
            className={this.props.classes.datePickerInput}
            calendarClassName={this.props.classes.datePickerCalender}
            name={this.props.name}
            placeholderText={this.props.placeholderText}
            minDate={this.props.selectMinDate}
            maxDate={this.props.selectMaxDate}
            selectsStart
            selected={this.state.startDate}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeStart}
          />
          <div className={this.props.classes.separator}>−</div>
          <ReactDatePicker
            id="date-picker-2"
            locale="ja"
            dateFormat={"yyyy/MM/dd"}
            dateFormatCalendar={"yyyy年MM月"}
            ref={(datePicker) => { this.datePickerEnd = datePicker }}
            className={this.props.classes.datePickerInput}
            calendarClassName={this.props.classes.datePickerCalender}
            name={this.props.name}
            placeholderText={this.props.placeholderText}
            minDate={this.props.selectMinDate}
            maxDate={this.props.selectMaxDate}
            selectsEnd
            selected={this.state.endDate}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeEnd}
          />
        </div>
      );
    } else {
      return (
        <ReactDatePicker
          id="date-picker"
          locale="ja"
          dateFormat={"yyyy/MM/dd"}
          dateFormatCalendar={"yyyy年MM月"}
          ref={(datePicker) => { this.datePicker = datePicker }}
          className={this.props.classes.datePickerInput}
          calendarClassName={this.props.classes.datePickerCalender}
          name={this.props.name}
          placeholderText={this.props.placeholderText}
          selected={this.state.startDate}
          onChange={this.handleChange}
        />
      );
    }
  }
}

DatePicker.defaultProps = {
  name: 'date-picker',
  placeholderText: '日付を選択',
  handleChange: () => { },
  isRange: false,
  startDate: new Date(),
  endDate: new Date(),
  selectMinDate: null,
  selectMaxDate: null,
}

DatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string,
  placeholderText: PropTypes.string,
  handleChange: PropTypes.func,
  isRange: PropTypes.bool,
  startDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  endDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  selectMinDate: PropTypes.instanceOf(Date),
  selectMaxDate: PropTypes.instanceOf(Date),
};

export default withStyles(styles)(DatePicker);



// WEBPACK FOOTER //
// ./src/components/Parts/DatePicker.jsx